import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'
import {ClientUserState} from './ClientUserState.ts'
import {UIAjaxWrapper} from './network/UIAjaxWrapper.ts'
import {UIAPIEndpoints} from './network/UIAPIEndpoints.ts'
import {logError} from './ui_utils/Utils.ts'

declare global {
    interface Window {
        useHelply?: boolean
        helplyAgentWidget?: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            identify(options: {token: string, user_metadata?: Record<string, string>}): Promise<void>
            setEscalationForm(options: {name?: string, email?: string}): void
        }
    }
}

export class HelplyLoader {
    private static readonly CONTAINER_SELECTOR = '#helply-agent-root-container'
    private static readonly BODY_SELECTOR = '[part="helply-agent-body"]'
    private static initialized = false

    static init() {
        if(!window.useHelply) return
        this.loadIfReady()
    }

    static initForFaqPage() {
        this.loadIfReady()
    }

    private static loadIfReady() {
        if(this.initialized) return
        if(!UIUtilsEjsVariables.helplyWidgetId) return
        if(!ClientUserState.userState?.isLoggedIn) return

        this.initialized = true
        this.loadWidget()
    }

    private static loadWidget() {
        const script = document.createElement('script')
        script.async = true
        script.setAttribute('data-agent', UIUtilsEjsVariables.helplyWidgetId)
        script.src = 'https://cdn.helply.com/helply-agent.js'
        document.head.appendChild(script)

        window.addEventListener('helplyAgentLoaded', () => {
            this.injectSafeAreaStyles()
            void this.identifyUser()
        })
    }

    private static injectSafeAreaStyles() {
        const container = document.querySelector(this.CONTAINER_SELECTOR)
        if(!container?.shadowRoot) return

        const style = document.createElement('style')
        const minTopOffset = 60
        const offset = `max(env(safe-area-inset-top, ${minTopOffset}px), ${minTopOffset}px)`
        style.textContent = `${this.BODY_SELECTOR} { top: ${offset} !important; height: calc(100% - ${offset}) !important; }`
        container.shadowRoot.appendChild(style)
    }

    private static async identifyUser() {
        try {
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiHelplyToken(), undefined, undefined, false)
            if(response?.json?.token == undefined) return

            await window.helplyAgentWidget?.identify({
                token: response.json.token,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                user_metadata: response.json.user_metadata,
            })

            window.helplyAgentWidget?.setEscalationForm({
                name: response.json.user_metadata?.username,
                email: response.json.user_metadata?.email,
            })
        } catch(error) {
            logError('HelplyLoader', ['Failed to identify user with Helply', error])
        }
    }
}
